import React from "react";
import BlockContent from "@sanity/block-content-to-react";
import Img from "gatsby-image/withIEPolyfill";
import getInternalLink from "./InternalLink";
import { getFluidGatsbyImage } from "gatsby-source-sanity";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import Video from "../components/video";
import { getPdfHref } from "./pdfLink";

const cfg = {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: "production",
};

const serializers = {
  types: {
    block: props => {
      const { style = "normal" } = props.node;

      if (/^h\d/.test(style)) {
        const level = style.replace(/[^\d]/g, "");
        return React.createElement(
          style,
          { className: `heading-${level}` },
          props.children
        );
      }

      if (props === undefined) {
        return "";
      }

      if (style === "blockquote") {
        return <blockquote>- {props.children}</blockquote>;
      }

      // Fall back to default handling
      return BlockContent.defaultSerializers.types.block(props);
    },
    youtube: props => {
      return (
        <Video
          options={{
            width: 600,
            aspectRatio: 16 / 9,
          }}
          youtube={props.node.url}
        ></Video>
      );
    },
  },
  marks: {
    strong: props => <strong>{props.children}</strong>,
    em: props => <em>{props.children}</em>,
    code: props => <code>{props.children}</code>,
    pdfLink: props => {
      const href = getPdfHref(props.mark);

      if (!href) {
        return props.children;
      }

      return (
        <OutboundLink
          eventCategory="PDF Download"
          action="Click"
          eventLabel={`Downloaded ${props.children}`}
          href={href}
          target="_blank"
          rel="noreferrer"
          download={true}
        >
          {props.children}
        </OutboundLink>
      );
    },
    internalLink: getInternalLink,
    link: ({ children, mark }) => (
      <OutboundLink
        eventCategory="External Link"
        action="Click"
        eventLabel={`External Link (CTA: ${children}, Link: ${mark.href})`}
        target="_blank"
        rel="noreferrer"
        href={mark.href}
      >
        {children}
      </OutboundLink>
    ),
  },
  undefined: props => {
    return "";
  },
  image: props => {
    if (props.node && props.node.asset) {
      let style = {
        width: "auto",
        maxHeight: "500px",
      };
      if (props.node.asset.metadata.dimensions.aspectRatio > 1) {
        style = { maxWidth: "100%", maxHeight: "320px", height: "auto" };
      }

      const fluidProps = getFluidGatsbyImage(props.node.asset._id, style, cfg);

      return (
        <div className="body-image-wrapper">
          <Img
            alt={props.node.alt || "Article Image"}
            className={
              props.node.asset.metadata.dimensions.aspectRatio > 1
                ? "landscape"
                : "portrait"
            }
            fluid={fluidProps}
            style={style}
            objectFit="contain"
          />
        </div>
      );
    }

    return "";
  },
};

export default serializers;
